export class FiltroProdutoMovimentoEstoque{
  ProdutoId: number;
  LocalEstoqueId: number | null;
  DataInicio: Date | null;
  DataFim: Date | null;
}
